export default defineI18nLocale(() => {
    return {
        // GENERIC
        back: 'Zurück',
        contact: 'Kontakt',
        copyright: 'Copyright © {year} woom GmbH. Alle Rechte vorbehalten.',
        country: 'Land',
        dealerLocator: 'Händlersuche',
        deliveryDays: {
            min: '4',
            max: '6',
        },
        free: 'kostenlos',
        language: 'Sprache',
        languageButton: 'Website aufrufen',
        loading: 'Ladevorgang',
        // newsletterSignup: 'Newsletter', // same as fallback
        newsletterUrl: '/newsletteranmeldung',
        next: 'weiter',
        'Phone number is not valid.': 'Das ist keine gültige Telefonnummer für das ausgewählte Land.',
        'Zip is not valid for Austria': 'Die Postleitzahl ist nicht korrekt.',
        tip: 'Tipp',
        algolia: {
            noResultHeading: 'Leider keine Treffer für',
            noResultMessage: 'Du suchst das passende Bike für dein Kind? Unser Radfinder hilft dir dabei!',
            popularSearchesHeading: 'Häufige Suchbegriffe',
        },
        cta: {
            cancel: 'Abbrechen',
            account: {
                account: 'Account',
                address: {
                    create: 'Adresse hinzufügen',
                    delete: 'Delete address - {context}',
                    update: 'Adresse bearbeiten - {context}',
                },
                bike: {
                    create: 'Rad hinzufügen',
                    delete: 'Delete bike  - {context}',
                    update: 'Rad bearbeiten - {context}',
                },
                delete: 'Löschen',
                kid: {
                    create: 'Kind hinzufügen',
                    update: 'Kind bearbeiten - {context}',
                },
                login: 'In deinen Account einloggen',
                logout: 'Ausloggen',
                openDropdown: 'Auswahlmenü Konto',
                orders: 'Bestellungen',
                profile: {
                    update: 'Profil bearbeiten',
                },
                save: 'Speichern',
            },
            badge: {
                close: 'Zeichen schließen',
                woom_icon_badge_plus: 'Rider-Protect-Plus-Zeichen öffnen',
                woom_icon_badge_safe: 'KIDSAFE-PLUS-Zeichen öffnen',
            },
            cart: {
                add: '{product} in den @:cart.base legen',
                addShort: 'Hinzufügen',
                buy: 'Jetzt kaufen',
                closeDrawer: 'Warenkorb schließen',
                closePromoDrawer: '{promo} schließen',
                checkout: 'Einkauf abschließen',
                lineItemDecrement: '{product} Anzahl verringern',
                lineItemIncrement: '{product} Anzahl erhöhen ',
                lineItemRemove: '{product} aus Warenkorb entfernen',
                openDrawer: 'Warenkorb öffnen',
                openPromoDrawer: '{promo} öffnen',
                options: 'Optionen',
            },
            closeDialog: 'Dialogfeld schließen',
            closeGalleryInfo: 'Infofeld schließen',
            cookieSettings: 'Cookie-Einstellungen',
            email: 'E-Mail-Adresse eingeben',
            form: {
                removeFile: 'Datei entfernen',
            },
            helpscout: 'Service & Kontakt',
            learnMore: 'Mehr erfahren',
            menu: {
                back: 'zum vorherigen Menü',
                closeMobile: 'Mobilmenü schließen',
                openMobile: 'Mobilmenü öffnen',
            },
            moreInfo: 'Mehr Info',
            network: 'zu unserem {network} Profil',
            notifyMe: 'Ich will auf die Warteliste!',
            openLanguageDrawer: 'Sprachauswahl öffnen',
            playVideo: 'Video abspielen',
            product: {
                view: '{product} ansehen',
            },
            questions: 'Fragen',
            readMore: '@.lower:cta.learnMore',
            reset: 'Zurücksetzen',
            search: 'Search',
            slider: {
                next: 'nächstes Bild',
                previous: 'vorheriges Bild',
            },
            sort: 'Sort',
            skipLink: 'Zum Hauptinhalt springen',
            viewBundle: '@.lower:cta.learnMore',
            viewDetails: 'Zeig mir mehr!',
        },
        // GROUPED TRANSLATIONS (alphabetic order)
        account: {
            add: 'Hinzufügen',
            easterEgg: 'Klingeling! Dein Fahrrad freut sich, dich zu sehen!',
            faq: 'Hier findest du noch alle %[FAQs](@:account.link.faq)% zum woom Riders Club.',
            heading: 'Hallo{nameWithSpace}!',
            maxLimitReached: '*Du hast die maximale Anzahlt von 5 {sectionTitle} erreicht.',
            address: {
                delete: {
                    title: 'Bist du sicher, dass du diese Adresse löschen möchtest?',
                    message:
                        'Sobald sie gelöscht wurde, ist die Adresse nicht mehr in deinem Konto sichtbar – und sie wird auch aus unserem System entfernt.',
                },
                update: {
                    title: '@:account.address.title',
                },
                default: 'Dies ist meine Standardadresse',
                defaultShort: 'Standardadresse',
                description: 'Spare Zeit bei deinem nächsten Einkauf!',
                empty: 'Du hast noch keine Adresse hinzugefügt. Vervollständige dein Profil, damit wir dir personalisierte Erlebnisse bereitstellen können.',
                messageAddressChangeLogistics:
                    'Eine Adressänderung hat aus logistischen Gründen keine Auswirkung auf eine Bestellung, die du in den letzten 48 Stunden getätigt hast.',
                sectionTitle: 'Adresse',
                title: 'Deine Adresse',
            },
            benefits: ['Geburtstags&shy;überraschung', 'woom-10-Jahres-Bike-Garantie', 'Tolle Angebote & Early Access', 'Exklusive Produkttests'],
            bikes: {
                color: '@:forms.color',
                delete: {
                    title: 'Willst du dieses Bike wirklich löschen?',
                    messages: [
                        'Nach dem Löschen ist das Bike nicht mehr in deinem Account sichtbar – und auch nicht mehr in unserem System gespeichert.',
                        'Im Garantiefall brauchst du dann die schriftliche Bestätigung und die Originalrechnung als Nachweis für die 10-Jahres-Garantie.',
                        'Diese Entscheidung kann nicht rückgängig gemacht werden.',
                    ],
                },
                update: {
                    title: '@:account.bikes.title',
                },
                description: 'Anmeldung zur 10-Jahres-Garantie und Übersicht eurer Bikes.',
                empty: 'Du hast noch kein Rad hinzugefügt. Registriere euer woom bike, damit du die woom 10-Jahres-Garantie aktivieren kannst.',
                messageKeepInvoice: 'Bitte bewahre die Rechnung für eventuelle Garantiefälle auf.',
                messageProfileIncomplete:
                    'Hinweis: Um die Bike Registrierung gültig abzuschließen, müssen alle Daten im Bereich “Profil” ebenfalls ausgefüllt werden.',
                off: {
                    firstGen: 'erste Generation, Modell 2021',
                    secondGen: 'zweite Generation, Modell 2023',
                },
                purchaseDate: 'Gekauft',
                purchaseDestination: 'Art des Kaufs',
                sectionTitle: 'Bikes',
                serialNumber: 'Rahmennummer',
                serialNumberInfo:
                    'Die Rahmennummer deines Fahrrads befindet sich auf der Unterseite des Rahmens. Um die Rahmennummer zu finden, dreh dein Fahrrad vorsichtig um und suche nach der eingravierten oder aufgedruckten Nummer auf dem Rahmen unterhalb des Tretlagers.',
                serialNumberInfoHidden:
                    'Für dein ausgewähltes Fahrradmodell existiert keine Rahmennummer. Dieses wurde ohne individuelle Rahmennummer produziert und ist daher nicht mit einer solchen identifizierbar.',
                title: 'Bike-Registrierung',
                purchaseOption: {
                    onlineShop: 'Ich habe das Rad in einem Online-Shop oder einem online Marktplatz gekauft',
                    onlineUsed: 'Auf einer Website für gebrauchte Räder (z. B. refurbed)',
                    onlineWoom: 'Im Online-Shop von woom (woom.com)',
                    private: 'Bei einem privaten Verkäufer oder einer privaten Verkäuferin (z. B. willhaben, ebay, Freunde)',
                    store: 'Bei einem woom Händler oder einer woom Händlerin (Im Shop)',
                },
            },
            footer: {
                questions: {
                    start: 'Falls du Fragen hast oder wir Daten von dir bearbeiten oder löschen sollten,',
                    middle: 'kontaktiere uns',
                    end: 'bitte direkt.',
                },
            },
            kids: {
                birthdate: 'Geboren am',
                description: 'Anmeldung zur Geburtstagsüberraschung',
                empty: 'Noch kein Kind hinzugefügt? Nenne uns den Namen und das Geburtsdatum deines Kindes bzw. deiner Kinder, dann erwartet euch jährlich eine kleine Geburtstagsüberraschung.',
                messageDataProcessing:
                    'Die Verarbeitung deiner Daten erfolgt wie in den %Riders Club AGB - @:account.link.termsConditions % und der %[Datenschutzinformation](@:account.link.privacyPolicy)% beschrieben, die ich damit zur Kenntnis genommen habe.',
                name: '',
                sectionTitle: 'Kinder',
                title: 'Dein Kind',
                tooOld: 'Es scheint, als hättest du ein Alter über 18 Jahren eingegeben.\nDer RidersClub ist nur für jüngere Abenteurer.',
            },
            link: {
                termsConditions: 'https://mediahub.woom.com/m/44ca25a8c307b6fa/original/AGB-Riders-Club_Stand-19-06-24.pdf',
            },
            newsletter: {
                subscription: `JA, ich möchte in Zukunft keine woom News mehr versäumen und per Newsletter über Produktneuheiten, Promotions, Gewinnspiele uvm. informiert werden. Für deine {'%{'}Newsletter-Anmeldung erhältst du von uns € 5,- € Rabatt{'}%'} auf deinen nächsten Einkauf.`,
                subscriptionDetail: `Du kannst die Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft hier, über unseren Kundenservice (%[woom{'@'}woom.com](mailto:woom{'@'}woom.com)%) oder direkt in den Newslettern widerrufen. Weitere Informationen bezüglich der Verarbeitung deiner Daten findest du %[hier](@:account.link.privacyPolicy)%.`,
                title: 'Newsletter',
            },
            orders: {
                cta: 'Zu deinen Bestellungen',
                description: 'Hier kannst du deine Bestellungen sehen.',
                paragraphEmpty: 'Du hast noch keine Bestellungen – stöbere jetzt in unserem Online-Shop!',
                title: 'Deine Bestellungen',
            },
            productTester: {
                cta: 'Zum Produkttest',
                description: 'Hier kannst du dich zu aktuellen Produkttests anmelden.',
                messageParticipation:
                    'Wir wählen die Teilnehmer*innen für jeden zukünftigen Produkttest zufällig aus.\nWenn dein Kind ausgewählt wird, benachrichtigen wir dich per E-Mail.',
                title: 'Werde Produkttester*in',
                url: '/woom-produkttest',
            },
            profile: {
                description: 'Halte hier deine Daten aktuell und profitiere von unseren Vorteilen.',
                empty: 'Wir wissen noch gar nicht wie du heißt.',
                messageConsent:
                    'Um dir die vollen Vorteile unseres Clubs bestmöglich bieten zu können, benötigen wir deine Einwilligung zur Kontaktaufnahme und Zusendung von Marketinginformationen. Du kannst die Einwilligung jederzeit hier, über unseren Kundenservice oder direkt in den Newslettern widerrufen.',
                messageConsentPending:
                    'Deine E-Mail-Adresse wurde noch nicht bestätigt. Bitte schau nochmal in deinen Posteingang und klicke in der E-Mail auf „E-Mail-Adresse bestätigen“.',
                messageDataProcessing: `Die Verarbeitung deiner Daten erfolgt wie in der %[Datenschutzinformation](@:account.link.privacyPolicy)% beschrieben, die ich damit zur Kenntnis genommen habe`,
                sectionTitle: 'Name',
                title: 'Dein Profil',
            },
            ridersClub: {
                headingNo: 'Melde dich zum woom Riders Club an!',
                headingYes: 'Willkommen im Riders Club',
                messageConsent: 'JA, ich möchte dem woom Riders Club beitreten und von den vielen Vorteilen des woom Riders Club profitieren.',
                messageConsentDetail:
                    'Mit der Teilnahme stimme ich den %Riders Club AGBs - @:account.link.termsConditions % zu. Die Verarbeitung deiner Daten erfolgt wie in den Riders Club AGBs und der %[Datenschutzinformation](@:account.link.privacyPolicy)% beschrieben, die ich damit zur Kenntnis genommen habe.',
            },
            shop: {
                cta: 'Zum Shop',
                url: '/fahrraeder',
            },
        },
        availability: {
            notifyMe: 'Ups, dieses Produkt ist gerade ausverkauft. Aber hey – wir sagen dir sofort Bescheid, sobald Nachschub anrollt.',
            notInThisRegion: 'Dieses Produkt ist in dieser Region nicht verfügbar.',
            inStock: {
                status: 'Sofort lieferbar',
                description: ' - Lieferung in {min} - {max} Werktagen',
            },
            lowStock: {
                status: 'Bald ausverkauft',
                description: ' - jetzt schnell sein!',
            },
            outOfStock: {
                status: 'Ausverkauft',
                description: ' - Nachschub ist unterwegs!',
            },
            weeks: '{period} Wochen',
            comingsoon: 'Derzeit nicht auf Lager. Voraussichtlich in {date} wieder bestellbar.',
            endOfLife: {
                status: 'Ausverkauft',
                description: ' – Nicht mehr im Sortiment',
            },
        },
        badges: {
            badgeDescription:
                'Alle Komponenten, die mit besonderem Fokus auf Sicherheit entwickelt wurden, sind mit dem KIDSAFE-PLUS-Zeichen gekennzeichnet.',
            woom_icon_badge_protect:
                'Alle Komponenten, die mit besonderem Fokus auf Sicherheit entwickelt wurden, sind mit dem RIDER-PROTECT-PLUS-Zeichen gekennzeichnet.',
            woom_icon_badge_safe: '@:badges.badgeDescription',
            woom_icon_badge_plus: '@:badges.badgeDescription',
        },
        bikeDetail: {
            age: 'Alter',
            bike: 'Größe',
            features: 'Besonderheiten',
            height: 'Größe',
            weight: 'Gewicht',
            years: 'Jahre',
            month: 'Monat | Monate',
        },
        bikefinder: {
            backToStart: 'zurück zum Anfang',
            label: 'Finde das passende Rad',
            resultQuery: 'ergebnis',
            age: 'Jahr alt | Jahre alt',
            maxAgeWarning: {
                heading: 'Das war’s',
                message: 'woom bikes passen leider nur bis 14 Jahre (dafür aber richtig gut!)',
            },
            selectHeight: 'Körpergröße',
            selectInseam: 'Innenbeinlänge',
            unit: {
                cm: 'Zentimeter',
                in: 'Zoll',
            },
            question: {
                previous: 'Vorherige Frage', // translated with AI
                next: 'Nächste Frage', // translated with AI
            },
            duration: 'Dauer: ca. 2 Minuten',
        },
        bikeGeometry: {
            crank: {
                length: 'Kurbelarmlänge',
            },
            handlebar: {
                height: 'Cockpit-/Griffhöhe',
                adjust: 'Lenkerverstellung',
            },
            height: 'Größe',
            label: 'Geometriedaten',
            length: 'Länge',
            saddle: {
                height: {
                    base: 'Sattelhöhe',
                    min: 'minimale @:bikeGeometry.saddle.height.base',
                    max: 'maximale @:bikeGeometry.saddle.height.base',
                },
            },
            seatTube: {
                angle: 'Sitzrohrwinkel',
            },
            standover: {
                height: 'Überstandshöhe',
            },
            steering: {
                angle: 'Lenkwinkel',
            },
            topTube: {
                horizontal: 'horizontale Oberrohrlänge',
            },
            wheel: {
                size: 'Reifen-/Laufradgröße',
                base: 'Radstand',
            },
            width: 'Breite',
        },
        bundleSelector: {
            baseProduct: 'Ohne Bundle',
            heading: 'Zubehör-Bundle wählen',
        },
        cart: {
            base: 'Warenkorb',
            empty: 'Dein @:cart.base ist leer. \nFinde jetzt das passende Fahrrad für dein Kind!',
            isLoading: 'Dein @:cart.base wird geladen',
            items: 'leer | 1 Artikel | {n} Artikel',
            limit: 'Bestelllimit erreicht',
            reviewCart: '@:cart.base überprüfen',
            subtotal: 'Zwischensumme',
            total: 'Gesamtsumme',
            yourCart: 'Dein @:cart.base',
            info0: 'Kostenloser Versand ab 99€',
            info1: '30 Tage Geld-zurück Garantie',
            info2: 'Kostenlose Retoure',
            info3: 'Lieferung innerhalb von @:deliveryDays.min ‑ @:deliveryDays.max Werktagen',
            info4: 'Kauf auf Rechnung',
            upsert: {
                errorFull: 'Ups, deine Auswahl konnte nicht in den Warenkorb gelegt werden. Versuchs nochmal oder kontaktiere uns.',
                errorPartial: 'Ups, ein Teil deiner Auswahl konnte nicht in den Warenkorb gelegt werden. Versuchs nochmal oder kontaktiere uns',
                success: 'Ride on – du hast deine Auswahl erfolgreich in den Warenkorb gelegt!',
            },
            // shipping: 'Versand',
            // additionalShippingCharges: 'Für übergroße Artikel können beim Check-out weitere Versandkosten hinzukommen.',
            // productUnavailable: 'Es tut uns leid, dieses Produkt ist momentan nicht verfügbar.',
            // maxQuantityReached: 'Es tut uns leid, die maximal verfügbare Anzahl für dieses Produkt ist {quantity}.',
            // limitedQuantityAvailable: 'Du hast {currentQuantity} in deinen Warenkorb gelegt, momentan sind aber nur {quantityAvailable} verfügbar.',
            // couldNotAdd: 'Das Produkt konnte dem Warenkorb nicht hinzugefügt werden.',
        },
        error: {
            homepage: 'Zur Startseite',
            404: `Wir können die aufgerufene Seite leider nicht finden.
    Vielleicht ist der Link ungültig oder die Seite ist umgezogen.`,
            503: `Uuuuups!
    Momentan ist dein Account-Bereich leider nicht verfügbar.
    Wir sind bald wieder für dich da.`,
            '5xx': `Uuuuups!
    There is something wrong with our servers.
    We will be back soon.`,
            adminApi: 'Es ist leider ein Fehler aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt noch einmal.',
        },
        forms: {
            addFile: 'Datei auswählen',
            address: 'Adresse',
            addressFail: "Wir konnten keine Adresse mit der Eingabe '{input}' finden.",
            apartment: 'Wohnung, Zimmer usw. (optional)',
            bikeModel: 'Fahrradmodel',
            birthdate: 'Geburtsdatum',
            changeBirthdateText: 'Falsches Datum? Bitte kontaktiere unser Service-Team, wenn du das Geburtsdatum ändern möchtest.',
            city: 'Stadt',
            clearFiles: 'entfernen',
            color: 'Farbe',
            country: 'Land/Region',
            email: 'E-Mail-Adresse',
            fileToLarge: 'Datei zu groß',
            fileExists: 'Datei schon hochgeladen',
            firstName: 'Vorname',
            formChanged: 'Eine Frage hat sich geändert.\nBitte überprüfe deine Eingabe noch einmal.',
            frameNumber: 'Rahmennummer',
            invalidValues: 'Bei der Überprüfung deiner Eingabe ist ein Fehler aufgetreten.\nBitte überprüfe deine Eingabe noch einmal.',
            lastName: 'Nachname',
            Mr: 'Herr',
            Mrs: 'Frau',
            name: 'Name',
            noEditEmail: 'Die für den Login verwendete E-Mail-Adresse kann nicht mehr geändert werden.',
            noFiles: 'Keine Datei ausgewählt',
            Others: 'Keine Angabe',
            phoneNumber: 'Telefon',
            purchaseDate: 'Kaufdatum',
            selectBike: 'Rad auswählen',
            state: 'Bundesstaat',
            submit: 'Abschicken',
            submitError: 'Beim Übertragen deiner Daten ist ein Fehler aufgetreten.\nBitte versuche es später noch einmal.',
            typeOfPurchase: 'Art des Kaufes',
            xOfYFiles: '{x} von bis zu {y} Dateien',
            zipCode: 'PLZ',
            validation: {
                required: 'Dieses Feld darf nicht leer sein.',
                email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
                select: 'Bitte triff eine Auswahl.',
                phoneNumber: 'Bitte gib eine gültige Telefonnummer ein.',
                // right: 'In den folgenden Feldern sind Fehler aufgetreten: {fields}',
                // age: 'Bitte gib dein Alter an.',
                // number: 'Bitte gib eine Zahl ein.',
                // file: 'Bitte lade ein Bild bzw. eine Datei hoch.',
                // consent: 'Wir brauchen Deine Zustimmung.',
            },
        },
        giftcard: {
            style: 'Stil',
            forMe: 'An mich versenden',
            forOther: 'Als Geschenk versenden',
            sendNow: 'Jetzt verschicken',
            sendNowText: 'Dein Gutschein wird nach Kaufabschluss sofort versandt.',
            schedule: 'Planen',
            scheduleInfo: 'Info: Das Zustell Datum ist basierend auf deiner Zeitzone.',
            forMeText: 'Du erhältst deinen Guschein nach Kaufabschluss per E-Mail.',
            formInvalid: 'Bitte alle Felder ausfüllen',
            labels: {
                senderName: 'Sender Name',
                recipientName: 'Empfänger Name',
                recipientEmail: 'Empfänger Email',
                recipientMessage: 'Nachricht an den Empfänger',
                deliveryDate: 'Zustell Datum',
            },
        },
        leggiekickstand: {
            label: 'LEGGIE Seitenständer für...',
        },
        price: {
            plusCustomFees: 'ggf. zzgl. Zollgebühren*',
            plusCustomFeesLink: 'https://hilfe.woombikes.com/article/590-fallen-fur-bestellungen-auserhalb-der-eu-zollgebuhren-an',
            priceFrom: 'ab {price}',
            tax: 'Preis inkl. MWSt. zzgl. Versandkosten',
            a11y: {
                strikeprice: 'stattpreis',
            },
        },
        product: {
            colors: 'Farbe | Farben',
            nameField: 'Name',
            successorMessage:
                'Das {oldProductTitle} ist in dieser Farbe nicht mehr verfügbar – aber wir haben etwas Neues für dich: das {newProductTitle}!',
            config: {
                front: 'vorne',
                rear: 'hinten',
            },
            option: {
                fits: 'Größe',
                size: 'Größe',
                config: 'Ausführung',
            },
            position: {
                front: '@:product.config.front',
                rear: '@:product.config.rear',
            },
            sizes: {
                guide: 'Größeninfo',
                s: 'Small',
                m: 'Medium',
                l: 'Large',
                xl: 'X-Large',
                'adult-s': 'S',
                'adult-m': 'M',
                'adult-l': 'L',
                'adult-xl': 'XL',
                5: '100/110',
                6: '110/120',
                7: '120/130',
                10: '130/140',
                11: '140/150',
                14: '150/160',
            },

            // estimateDeliveryDate: 'voraussichtliches Lieferdatum',
            // quantity: 'Ein Artikel auf Lager.  | {n} Artikel auf Lager.',
            // reviews: 'Keine Bewertungen | Eine Bewertung | {n} Bewertungen',
            // estimatedShipping: 'voraussichtliche Versandkosten',
            // estimatedTaxes: 'voraussichtliche Steuern',
            // estimatedTotal: 'voraussichtliche Gesamtsumme',
            // design: 'Design',
            // position: 'Position',
            // edition: 'Edition',
            // language: 'Sprache',
            // matchingProducts: 'Diese Produkte passen dazu',
            // variant: {
            //     front: 'vorne',
            //     rear: 'hinten',
            //     left: 'links',
            //     right: 'rechts',
            //     en: 'Englisch',
            //     de: 'Deutsch',
            // },
            // specs: {
            //     label: 'Spezifikationen',
            // },
        },
        reviews: {
            attributes: {
                '9065': {
                    label: 'Wie bewertest du die Qualität?',
                    options: ['schlecht', 'gut', 'ausgezeichnet'],
                },
            },
            badgeRecommendation: 'Ich würde das Produkt weiterempfehlen.',
            badgeVerifiedCustomer: 'Verifizierte*r Käufer*in',
            empty: 'Schreibe die erste Bewertung für das Produkt {productName}',
            heading: 'Bewertungen & Rezensionen',
            helpfulReviewButton: {
                idle: 'Ja',
                submitted: 'abgestimmt',
                submitting: 'wird verarbeitet …',
            },
            helpfulReviewDisplay: '{count} Person fand das hilfreich. | {count} Personen fanden das hilfreich.',
            helpfulReviewHeading: 'War diese Bewertung hilfreich?',
            reviewTotalLong: ' Basierend auf {count} Bewertung | Basierend auf {count} Bewertungen',
            reviewTotalShort: '{count} Bewertung | {count} Bewertungen',
            starNumbers: {
                '1': 'eins',
                '2': 'zwei',
                '3': 'drei',
                '4': 'vier',
                '5': 'fünf',
            },
            starRating: '{count}-Sterne-Bewertung',
        },
        upsell: {
            extras: 'Diese Produkte könnten dich auch interessieren',
        },
        // ############### UNUSED ###################
        // discover_bikes: {
        //     open_bike_category: {
        //         original: 'Entdecke die woom ORIGINAL bikes',
        //         off_off_air: 'Mountainbikes entdecken',
        //         up: 'E-Mountainbikes entdecken',
        //         now: 'woom NOW entdecken',
        //     },
        // },
    };
});
